import { Component, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { environment } from '../../../environments/environment';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { Documento } from '../../models/documento/documento.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab9',
  templateUrl: '../../pages/afiliacion/afiliacion.tab9.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.component.css']
})
export class AfiliacionTab9Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    @Input() afiliado: Afiliado;
   
    diasDiferencia: any;
	postulantes: any[];


    constructor(private router:Router, private escolaridadService:EscolaridadService,        
                private productosService:ProductosService, private dialog: MatDialog,
                private afiliadoService: AfiliacionService) { }

    ngOnInit(): void
    {    let vm = this
     
    }
   

    onDescargarArchivosClick(url: any) {
        let vm = this     
        var fileURL = `${environment.urlBlob}/${url}`
        window.open(fileURL, '_blank')
             
    }
    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
